import styled from 'styled-components';

export const Wrapper = styled.div`
  //display: block;
  //height: 100%;
  //flex-direction: row;
  display: grid;
  grid-template-rows: 50px auto;

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  }
`;

export const WrapperTable = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1.5rem;
  height: 50%;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;

    > div:not(:first-child) {
      margin-top: 1.5rem;
    }
  }
`;

export const WrapperHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem 0;
  margin-top: -1rem;
  margin-bottom: 1rem;
`;

export const WrapperFormInput = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;
